import * as React from 'react'
import { IStageProps, IPoint } from 'app/types'
import Clock from 'app/comp/clock'
import Combo from 'app/comp/combo'
import Hint from 'app/comp/hint'
import StageCounter from 'app/comp/stage-counter'

import DocumentEventHandler from 'app/comp/document-event-handler'


const TEXT = `The light we cannot see...`


export default class FilterStage extends React.Component<IStageProps, {
  mouseP?: IPoint
  isMouseDown: boolean
  hasClicked: boolean
}> {

  timeout: number

  constructor(props) {
    super(props)

    this.state = {
      mouseP: undefined,
      isMouseDown: false,
      hasClicked: false
    }
  }

  handleMouseMove = event => {
    this.setState({
      mouseP: {x: event.clientX, y: event.clientY}
    })
  }

  handleMouseDown = () => {
    this.setState({
      isMouseDown: true,
      hasClicked: true
    })
  }

  handleMouseUp = () => {
    this.setState({
      isMouseDown: false
    })
  }

  getHintText(): string {
    const { hasClicked } = this.state

    if (hasClicked) {
      return "Its some kind of light. Lets see what I can find with it."
    } else {
      return "I was hoping this problem would just click. I guess I'll just keep trying."
    }
  }

  renderLight() {
    const {
      isMouseDown,
      mouseP
    } = this.state

    if (!mouseP) {
      return
    }

    const style: any = {
      position: 'absolute',
      left: mouseP.x - 30,
      top: mouseP.y - 30,
      backgroundColor: isMouseDown ? '#9b59b6' : 'white',
      width: 70,
      height: 70,
      borderRadius: 35,
      zIndex: -1
    }

    return (
      <div style={style} />
    )
  }

  render() {
    return (
      <div>

        <DocumentEventHandler
          onMouseDown={this.handleMouseDown}
          onMouseUp={this.handleMouseUp}
          onMouseMove={this.handleMouseMove}
        />

        <Hint
          onAddTime={this.props.onAddTime}
          delay={1 * 60 * 1000}
          text={this.getHintText()}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        {this.renderLight()}

        <div style={{textAlign: 'center', position: 'absolute', top: 0, left: 0, width: '100vw'}}>
          <span draggable={false} style={{textAlign: 'center', userSelect: 'none', color: 'white', fontSize: '20vw', zIndex: 10}}>imagine</span>
        </div>

        <div style={{textAlign: 'center', position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <h1 style={{userSelect: 'none', zIndex: 100, fontSize: '5vw'}}>{TEXT}</h1>
        </div>


        <div style={{zIndex: 20, position: 'absolute', bottom: 12, left: 0, width: '100vw', textAlign: 'center'}}>
          <Combo code="IMAGINE" onSolve={this.props.onNext} />
        </div>

      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/blacklight.tsx